import http from 'src/http/fetchClient';
import CONTENT_TYPES from './contentTypes';

class UserService {
  getUserById = (id) =>
    http.get(`/api/admin/accounts/users/${id}`, {
      headers: {
        'Content-Type': CONTENT_TYPES.accounts_adminUser
      },
      data: {}
    });
}

const userService = new UserService();

export default userService;
